(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
'use strict';

(function ($) {
  /**
   * @constructor
   */
  function AjaxPaginationFilter(options) {
    this.options = options || {};
    this.$body = $('body');
    this.$form = $(options.elements.form);
    this.$results = $(options.elements.results);
    this.$pagination = $(options.elements.pagination);
    this.$loader = $(options.elements.loader);
    this.$counter = $(options.elements.counter);
    this.baseUrl = this.getCleanUrl(window.location.href);
    this.addEvents();
  }

  $.extend(AjaxPaginationFilter.prototype, {
    cache: {},

    /**
     * Add event listeners
     */
    addEvents: function () {
      var elements = this.options.elements || {};
      this.$pagination.on('click', 'a', this.onPageClick.bind(this));
      this.$form.on('change', ':input', this.fetch.bind(this));

      if (elements.reset) {
        this.$body.on('click', elements.reset, this.onResetClick.bind(this));
      }

      if (elements.mobileToggle) {
        this.$body.on('click', elements.mobileToggle, this.onMobileToggleClick.bind(this));
      }
    },

    /**
     * Create request data
     * @return {Object}
     */
    createRequestData: function () {
      var arrayFormat = /\[.*?\]$/;
      var serializeArray = this.$form.serializeArray();
      var data = {}; // Extend with default parameters

      if (typeof this.options.defaultParameters === 'object') {
        $.extend(data, this.options.defaultParameters);
      } // Convert array to object


      serializeArray.forEach(function (input) {
        var key = input.name;
        var value = input.value; // Check if array format

        if (arrayFormat.test(key)) {
          key = key.replace(arrayFormat, '');
          value = key in data ? data[key].concat(value) : [value];
        }

        data[key] = value;
      }); // Required parameters for pagination

      data.paged = this.pageIndex;
      data.base_url = this.baseUrl;
      return data;
    },

    /**
     * Fetch AJAX results
     * @return {Promise}      [description]
     */
    fetch: function () {
      var self = this;
      var data = this.createRequestData();
      var hash = $.param(data); // Abort possible active XHR request

      if (this.xhr) {
        this.xhr.abort();
      } // Save state to URL


      if (this.options.pushState) {
        this.pushState(data);
      } // Render directly from cache?


      if (this.options.enableCache && hash in this.cache) {
        this.propagate(this.cache[hash]);
        return $.Deferred().resolve();
      } // Set loading state


      if (this.options.loadingClass) {
        this.$loader.addClass(this.options.loadingClass);
      } // Initiate request


      this.xhr = $.post(themevars.ajaxurl, data).done(function (response) {
        // Render HTML
        self.propagate(response.data); // Cache response

        self.cache[hash] = response.data;
      }).fail(function (jqXHR) {// error reporting
      }).always(function (response) {
        if (self.options.loadingClass) {
          self.$loader.removeClass(self.options.loadingClass);
        }

        self.xhr = null;
      });
      return this.xhr;
    },

    /**
     * Render HTML from AJAX request
     * @param  {Object} data [description]
     * @return {[type]}      [description]
     */
    propagate: function (data) {
      var empty = '<!-- empty -->';
      this.$results.html(data.posts.html || empty);
      this.$pagination.html(data.pagination.html || empty);
      this.$counter.each(function () {
        var text = data.pagination.post_total || $(this).data('empty-results');
        $(this).text(text);
      });
    },

    /**
     * Get page index from URL string
     * @param  {[type]} url [description]
     * @return {Number|null}     [description]
     */
    getPageIndex: function (url) {
      var matches = url.match(new RegExp(this.options.pageRegex));

      if (matches) {
        return parseInt(matches[1], 10);
      }

      return null;
    },

    /**
     * Get clean URL (without query string)
     * @param {String} url
     * @return {String}
     **/
    getCleanUrl: function (url) {
      return url.split('?')[0];
    },

    /**
     * Navigate to a page
     * @param  {jQuery.Event} e [description]
     * @return {[type]}   [description]
     */
    onPageClick: function (e) {
      var href = $(e.currentTarget).attr('href');
      e.preventDefault();
      $('html, body').animate({
        scrollTop: 0
      });
      this.pageIndex = this.getPageIndex(href) || 1;
      this.baseUrl = this.getCleanUrl(href);
      this.fetch();
    },

    /**
     * Reset button click
     * @param {jQuery.Event} e
     **/
    onResetClick: function (e) {
      e.preventDefault();
      this.reset();
    },

    /**
     * Remove keys from object
     * @param  {Object} obj  [description]
     * @param  {Array} keys [description]
     * @return {Object}      [description]
     */
    omit: function (obj, keys) {
      var objClean = $.extend({}, obj);
      var blacklist = keys || [];

      for (var key in objClean) {
        if (blacklist.indexOf(key) !== -1) {
          delete objClean[key];
        }
      }

      return objClean;
    },

    /**
     * Keep keys from object
     * @param  {Object} obj  [description]
     * @param  {Array} keys [description]
     * @return {Object}      [description]
     */
    keep: function (obj, keys) {
      var objClean = $.extend({}, obj);
      var whitelist = keys || [];

      for (var key in objClean) {
        if (whitelist.indexOf(key) === -1) {
          delete objClean[key];
        }
      }

      return objClean;
    },

    /**
     * Reset filters/state
     **/
    reset: function () {
      this.$form.find('[name="post_tag[]"]').prop('checked', false);
      this.$form.find('[name="author_function[]"]').prop('checked', false);
      this.fetch();
    },

    /**
     * Show/hide filters on mobile
     **/
    onMobileToggleClick: function (e) {
      e.preventDefault();
      this.$body.toggleClass('category-overlay');
    },

    /**
     * Push state to URL
     * @param  {Object} data [description]
     * @return {[type]}
     */
    pushState: function (data) {
      var url = this.baseUrl;
      var filters = this.keep(data, ['orderby', 'author_function', 'post_tag']);
      var params = $.param(filters);
      var prevState = this.currentState || {};
      var queryString = ''; // When params changed, remove possible page number (set state to first page)

      if (prevState.params && prevState.params !== params) {
        url = url.replace(new RegExp(this.options.pageRegex), '/');
      } // Append query string if needed


      if (params) {
        queryString = '?filter=' + encodeURIComponent(params);
      }

      this.currentState = {
        data: data,
        params: params,
        pageIndex: this.pageIndex
      }; // Detect if browser supports pushState

      if (window.history.pushState) {
        window.history.pushState(this.currentState, document.title, url + queryString);
      } else {
        window.location.hash = '#' + queryString;
      }
    }
  }); // Publicly Expose

  window.AjaxPaginationFilter = AjaxPaginationFilter;
})(jQuery);

},{}],2:[function(require,module,exports){
require("./components/ajax-pagination-filter.js");

(function (window, document, $) {
  $(document).ready(function () {
    'use strict';

    if ($('.category__sidebar-group').length) {
      $('.category__sidebar-group').each(function () {
        if (!$(this).find('label.label-hidden').length) {
          $(this).find('.category__sidebar-group__show-more').addClass('hidden');
        }
      });
    } // show more filter options


    $('.category__sidebar-group__show-more').on('click', function (e) {
      e.preventDefault();
      $(this).parent().find('label.label-hidden').removeClass('label-hidden').addClass('label-was-hidden');
      $(this).parent().find('.category__sidebar-group__show-less').removeClass('hidden');
      $(this).addClass('hidden');
    }); // show less filter options

    $('.category__sidebar-group__show-less').on('click', function (e) {
      e.preventDefault();
      $(this).parent().find('label.label-was-hidden').each(function () {
        if (!$(this).find('input[type=checkbox]:checked').length) {
          $(this).removeClass('label-was-hidden');
          $(this).addClass('label-hidden');
        }
      });
      $(this).parent().find('.category__sidebar-group__show-more').removeClass('hidden');
      $(this).addClass('hidden');
    }); //Mailchimp via AJAX

    function register($form) {
      jQuery.ajax({
        type: "GET",
        url: $form.attr('action'),
        data: $form.serialize(),
        cache: false,
        dataType: 'jsonp',
        contentType: "application/json; charset=utf-8",
        error: function (err) {
          console.log('error');
        },
        success: function (data) {
          if (data.result == "success") {
            $(".intro-message").addClass('hide');
            $(".email-form").addClass('hide');
            $(".success-message").removeClass('hide');
          } else if (data.result == "error" && $(data.result).index("already subscribed")) {
            $(".exist-message").removeClass('hide');
          } else {
            $(".error-message").removeClass('hide');
          }
        }
      });
    } // waits for form to appear rather than appending straight to the form. Also helps if you have more than one type of form that you want to use this action on.


    jQuery(document).on('submit', '#mc-embedded-subscribe-form', function (event) {
      //define argument as the current form especially if you have more than one
      var $form = jQuery(this);
      var $checkbox = $('#gdpr_22521'); // stop open of new tab

      event.preventDefault();
      $form.find('.message').remove(); // console.log($checkbox, $checkbox.is(':checked'));
      // return;

      $checkbox.hide();

      if (!$checkbox.is(':checked')) {
        $checkbox.hide();
        $checkbox.closest('label').after('<div class="message">Checkbox is verplicht</div>'); //$('<div class="message">Dit is verplicht</div>').insertAfter('[for="gdpr_22521"]');

        return;
      } // submit form via ajax


      register($form);
    });
  }); //$('<div class="message">Dit is verplicht</div>').insertAfter('.email-form');
})(window, document, jQuery);

},{"./components/ajax-pagination-filter.js":1}]},{},[2]);
